<template>
    <div class="online_success no-trans" v-loading="loading">
        <div class="online_success_box">
            <!-- <div class="titles_box">确认结算相关信息</div>
            <div class="form_box">
                <div class="forms">
                    <div class="form_title"><span>*</span>真实姓名</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="forms">
                    <div class="form_title"><span>*</span>手机号</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="forms">
                    <div class="form_title"><span>*</span>电子邮箱</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
            </div> -->
            <div class="titles_box">支付</div>
            <div class="check_box">
                <div class="checks">
                    <div class="check_title">支付方式：</div>
                    <div class="check_check">
                        <div class="items_flex" v-for="(item, index) in pay_list" :key="index"
                            @click="handle_pay(item, index)">
                            <div class="item_check">
                                <img src="@/assets/img/index/legal/checks_no.png" alt="" v-if="pay_ac != index">
                                <img src="@/assets/img/index/legal/checks_ac.png" alt="" v-if="pay_ac == index">
                            </div>
                            <div class="item_img">
                                <img :src="item.images" alt="">
                            </div>
                            <div class="item_title">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="checks">
                    <div class="check_title">是否开票：</div>
                    <div class="check_check2">
                        <el-radio v-model="kp_ac" :label="1">不需要开票</el-radio>
                        <el-radio v-model="kp_ac" :label="2">需要开票</el-radio>
                    </div>
                    <div class="btns_box" v-if="kp_ac==1" @click="$router.push('/user_gl/user_gl_detial')">
                        <div class="btns">新增发票</div>
                    </div>
                </div>
                <div class="checks">
                    <div class="check_title"></div>
                    <div class="check_check3">
                        <div class="fp_list" v-for="(item, index) in fp_list" :key="index"
                            @click="handle_fp(item, index)">
                            <div class="fp_check">
                                <img src="@/assets/img/index/legal/fp_ac.png" alt="" v-if="index == fp_ac">
                                <img src="@/assets/img/index/legal/fp_no.png" alt="" v-if="index != fp_ac">
                            </div>
                            <div class="fp_info">
                                <div class="info_name">公司名称</div>
                                <div class="info_nums">税号：123123123123123</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="titles_box">订单商品</div>
            <div class="table_box">
                <!-- @header-row-class-name="header_row_class_name" -->
                <el-table :data="shop_list" height="250"style="width: 100%" :header-row-class-name="'table_titles'" >  
                    <el-table-column prop="date" label="产品名称" width="500" :header-align="'left'">
                        <template slot-scope="scope">
                            <div class="cp_name">
                                <div class="imgs">
                                    <img src="../../assets/img/index/legal/shops.png" alt="">
                                </div>
                                产品名称
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="加个" width="180">
                        <template slot-scope="scope">
                            <div class="prices">
                                ￥123123
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="数量">
                        <template slot-scope="scope">
                            <div class="nums">
                                X123123
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="小计">
                        <template slot-scope="scope">
                            <div class="prices">
                                ￥123123
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="price_box">
                    <div class="price_text">合计：</div>
                    <div class="price_num">￥123123</div>
                </div>
                <div class="yqm_box">
                    <div class="yqm_titles">邀请码</div>
                    <div class="yqm_inputs">
                        <el-input v-model="input" placeholder="请输入邀请码"></el-input>
                    </div>
                </div>
                <div class="btns_flex">
                    <div class="btns1" @click="handle_black">返回</div>
                    <div class="btns2" @click="handle_end">去支付</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'




export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            input: '',
            pay_ac: 0,
            pay_list: [
                {
                    title: '微信支付',
                    images: require('../../assets/img/index/legal/pay_wx.png'),
                },
                {
                    title: '支付宝支付',
                    images: require('../../assets/img/index/legal/pay_zfb.png'),
                },
                {
                    title: '网银支付',
                    images: require('../../assets/img/index/legal/pay_wy.png'),
                },
                {
                    title: '线下转款',
                    images: require('../../assets/img/index/legal/pay_xx.png'),
                },
                {
                    title: '佣金支付',
                    images: require('../../assets/img/index/legal/pay_yj.png'),
                },
            ],
            kp_ac: 2,//
            fp_ac: 0,
            fp_list: [1, 2, 3, 4],
            shop_list: [
                {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                },
            ]
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_pay(item,i){

        },
        handle_detial() {

        },
        //返回首页
        handle_black() {
            this.$router.push({
                path: '/home'
            })
        },
        handle_end(item, index) {
            this.$router.push({
                path: '/online_success'
            })
        },
      

    },

}
</script>
<style scoped lang="less">
.online_success {
    width: 100%;
    //    height: 600px;
    background-color: #FFFFFF;
    padding-bottom: 100px;

    .online_success_box {
        width: 1440px;
        height: 100%;
        padding-top: 30px;
        margin: auto;

        .titles_box {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;
            padding-bottom: 16px;
            border-bottom: 2px solid #D5D8DE;
        }

        .form_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 24px;
            padding-bottom: 48px;

            .forms {
                .form_title {

                    font-weight: normal;
                    font-size: 14px;
                    color: #666666;

                    span {
                        color: #FD4C5C;
                    }

                }

                .form_input {
                    width: 440px;
                    height: 44px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    margin-top: 17px;
                }
            }
        }

        .check_box {
            padding: 0 32px;

            .checks {
                display: flex;
                align-items: center;
                padding-top: 43px;

                .check_title {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    width: 80px;
                }

                .check_check {
                    display: flex;

                    .items_flex {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        margin-right: 80px;

                        .item_check {
                            display: flex;
                            align-content: center;

                            img {
                                width: 21px;
                                height: 21px;
                            }
                        }

                        .item_img {
                            margin-left: 16px;

                            img {
                                width: 39px;
                            }
                        }

                        .item_title {
                            padding-left: 10px;
                            font-weight: 400;
                            font-size: 16px;
                            color: #000000;

                        }
                    }


                }

                .check_check2 {}
                .btns_box{
                    display: flex;
                    align-items: center;
                    margin-left: 20px;
                    .btns{
                        cursor: pointer;
                        color: #377CFD;
                        font-weight: 400;
                        font-size: 14px;
                    }

                }
                .check_check3 {
                    .fp_list {
                        width: 1288px;
                        height: 102px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #EAEBEE;
                        margin-bottom: 20px;
                        padding: 27px 17px;
                        cursor: pointer;
                        display: flex;

                        // align-items: center;
                        .fp_check {
                            width: 18px;
                            height: 18px;
                            flex-shrink: 0;

                            img {
                                width: 18px;
                                height: 18px;
                            }
                        }

                        .fp_info {
                            flex: 1;
                            display: flex;
                            // align-items: center;
                            flex-wrap: wrap;
                            align-content: space-between;
                            padding-left: 25px;

                            .info_name {
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;

                            }

                            .info_nums {
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                    }
                }
            }
        }
        .table_box{
            padding-top: 24px;
            /deep/.el-table{
                .el-table__header-wrapper{
                    .table_titles{
                        .el-table__cell{
                            background-color: #FAFBFC;
                            .cell{
                                text-align: left;
                                padding-left: 48px;
                            }
                        }
                    }
                }
                .cp_name{
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    padding-left: 48px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;

                    .imgs{
                        width: 64px;
                        height: 64px;
                        // margin-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
                .prices{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    text-align: left;
                    padding-left: 28px;

                }
                .nums{
                    padding-left: 48px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: left;

                }
            }
            .price_box{
                width: 1440px;
                height: 56px;
                background: #FAFAFA;
                border-radius: 0px 0px 0px 0px;
                display:flex;
                align-items: center;
                justify-content: end;
                padding: 0 40px;
                .price_text{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;

                }
                .price_num{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #377CFD;
                }
            }
            .yqm_box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-top: 25px;
                .yqm_titles{
                   
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    margin-right: 18px;
                }
                .yqm_inputs{

                }
            }
            .btns_flex{
                display: flex;
                align-items: center;
                justify-content: end;
                padding-top: 24px;
                .btns1{
                    width: 191px;
                    height: 46px;
                    background: #FFFFFF;
                    border: 1px solid #377CFD;
                    cursor: pointer;
                    text-align: center;          
                    line-height: 46px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #377CFD;
                    border-radius: 8px;

                }
                .btns2{
                    width: 191px;
                    height: 46px;
                    background: #377CFD; 
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 46px;
                    cursor: pointer;
                    text-align: center;
                    border-radius: 8px;
                    margin-left:24px ;
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .online_success.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .online_success.no-trans .online_success_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-top: 16px;
        margin: auto;
    }
    .online_success.no-trans .online_success_box .titles_box {
        font-size: 24px;
        padding-bottom: 16px;
    }
    .online_success.no-trans .online_success_box .form_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .online_success.no-trans .online_success_box .form_box .forms .form_title {
        font-size: 14px;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .online_success.no-trans .online_success_box .form_box .forms .form_input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 44px;
        border-radius: 2px 2px 2px 2px;
        margin-top: 16px;
    }
    .online_success.no-trans .online_success_box .check_box {
        padding: 0 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_title {
        font-size: 14px;
        width: 80px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex .item_check {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex .item_check img {
        width: 21px;
        height: 21px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex .item_img {
        margin-left: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex .item_img img {
        width: 39px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check .items_flex .item_title {
        padding-left: 10px;
        font-size: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .btns_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-left: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .btns_box .btns {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
        padding: 16px 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list .fp_check {
        width: 18px;
        height: 18px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list .fp_check img {
        width: 18px;
        height: 18px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list .fp_info {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-left: 16px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list .fp_info .info_name {
        font-size: 14px;
    }
    .online_success.no-trans .online_success_box .check_box .checks .check_check3 .fp_list .fp_info .info_nums {
        font-size: 14px;
    }
    .online_success.no-trans .online_success_box .table_box {
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .el-table__header-wrapper .table_titles .el-table__cell .cell {
        padding-left: 16px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .cp_name {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-left: 16px;
        font-size: 14px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .cp_name .imgs {
        width: 64px;
        height: 64px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .cp_name .imgs img {
        width: 30px;
        height: 30px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .prices {
        font-size: 14px;
        padding-left: 16px;
    }
    .online_success.no-trans .online_success_box .table_box /deep/ .el-table .nums {
        padding-left: 16px;
        font-size: 14px;
    }
    .online_success.no-trans .online_success_box .table_box .price_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .online_success.no-trans .online_success_box .table_box .price_box .price_text {
        font-size: 14px;
    }
    .online_success.no-trans .online_success_box .table_box .price_box .price_num {
        font-size: 20px;
    }
    .online_success.no-trans .online_success_box .table_box .yqm_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .table_box .yqm_box .yqm_titles {
        font-size: 14px;
        margin-right: 16px;
    }
    .online_success.no-trans .online_success_box .table_box .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .table_box .btns_flex .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        line-height: 1.6;
        font-size: 16px;
        border-radius: 8px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_success.no-trans .online_success_box .table_box .btns_flex .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        font-size: 16px;
        line-height: 1.6;
        border-radius: 8px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
